import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'
import { COLORS, SIZES } from '../../styles/theme'
import config from '../../config'
// import logo from '../../images/event-logo.png'
// import banner from '../../images/registration/bannerL.png'
// import bannerM from '../../images/registration/bannerP.png'

const Page = styled.div`
  min-height: 100vh;
  height: 100vh;
  background-image: url(${config.assets.entrance.landscape});
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  color: #FFFFFF;
  padding-bottom: 4.5em;
  padding-top: 3em;
  text-transform: uppercase;

  .mobile-show {
    display: none;
  }
  .brand {
    width: 80%;
    min-height: 75vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  #message {
    background-color: rgba(255, 255, 255, 0.65);
    border: 3px dashed #00A100;
    border-radius: 12px;
    width: 70%;
    color: #00A100;
    margin: 0 auto;
    padding: 1.5rem 2rem;
    text-align: center;
    .icon {
      width: 100px;
      margin: 0 auto;
    }
    h5 {
      font-weight: 600;
      font-size: 18px;
    }
  }
  ${SIZES.mobile} {
    padding: 1em 0;
    background-image: url(${config.assets.entrance.portrait});
    .mobile-hide {
      display: none;
    }
    .mobile-show {
      display: block;
    }
    img#banner-portrait {
      display: block;
    }
    #message {
      font-size: 0.75em;
      padding: 1.5rem 1rem;
      width: 85%;
    }
    .col-md-6 {
      flex: none;
      max-width: 100%
    }
  }
`

export default function PostRegisterPage() {

  return (
    <Page>
      <Row noGutters className="h-100">
        <div className="w-100 mobile-show">
          {/* <img width="100%" src={bannerM} alt="event-banner" className="mx-auto my-2" /> */}
        </div>
        <Col md={6} className="align-self-center mt-4 mt-md-0 mobile-hide">
          <div className="brand">
            {/* <img width="100%" src={banner} alt="event-banner" className="d-block ml-0 mr-auto" /> */}
            {/* <img width="60%" src={logo} alt="event-logo" className="d-block mr-0 ml-auto" /> */}
          </div>
        </Col>
        <Col md={6} className="align-self-center">
          <div id="message" className="mt-5">
            <div className="icon">
              <svg width="92.936" height="92.936" viewBox="0 0 92.936 92.936">
                <path d="M48.468,2A46.468,46.468,0,1,0,94.936,48.468,46.485,46.485,0,0,0,48.468,2Zm0,83.643A37.174,37.174,0,1,1,85.643,48.468,37.224,37.224,0,0,1,48.468,85.643ZM66.5,31.228,39.174,58.552l-8.736-8.736a4.633,4.633,0,0,0-6.552,6.552L35.922,68.4a4.628,4.628,0,0,0,6.552,0L73.1,37.78a4.628,4.628,0,0,0,0-6.552,4.684,4.684,0,0,0-6.6,0Z" transform="translate(-2 -2)" fill="#00A100"/>
              </svg>
            </div>
            <h5>
              Thank you for your registration and you will receive a confirmation email soon.
            </h5>
          </div>
        </Col>
        <div className="mobile-show mb-3 mb-md-5 mt-auto">
          {/* <img width="40%" src={logo} alt="event-logo" className="d-block mx-auto" /> */}
        </div>
      </Row>
    </Page>
  )
}
